import React from "react";
import { useFormikContext, getIn, ErrorMessage } from "formik";
import FormikInputField from "./FormikInputField";
import { CorporateTheme } from "../../utils/themes";
import { formErrorMessage } from "./FormErrorMessage";

interface FormikNumberRangeFieldProps {
  name: string; // e.g., "conditions[0].value"
  label?: string;
  className?: string;
  placeholderFrom?: string;
  placeholderTo?: string;
}

const FormikNumberRangeField: React.FC<FormikNumberRangeFieldProps> = ({
  name,
  label,
  className = "",
  placeholderFrom = "Min",
  placeholderTo = "Max",
}) => {
  const { values, errors, touched, setFieldValue } = useFormikContext<any>();
  const rangeValue: [number | null, number | null] = getIn(values, name) ?? [
    null,
    null,
  ];

  const error0 = getIn(errors, `${name}[0]`);
  const error1 = getIn(errors, `${name}[1]`);
  const touched0 = getIn(touched, `${name}[0]`);
  const touched1 = getIn(touched, `${name}[1]`);

  const showError0 = error0;
  const showError1 = error1;

  return (
    <div className={`d-flex flex-column ${className}`}>
      {label && <label className="mb-1">{label}</label>}

      <div className="d-flex gap-2 align-items-center">
        <div className="d-flex flex-column">
          <FormikInputField
            type="number"
            name={`${name}[0]`}
            placeholder={placeholderFrom}
            style={{
              maxWidth: "100px",
              height: "36px",
              borderColor: showError0 && CorporateTheme?.colors?.danger,
            }}
          />
          {showError0  && (
            <ErrorMessage name={name} render={formErrorMessage} />
          )}
        </div>

        <span className="mx-1">to</span>
        <div className="d-flex flex-column">
          <FormikInputField
            type="number"
            name={`${name}[1]`}
            placeholder={placeholderTo}
            style={{
              maxWidth: "100px",
              height: "36px",
              borderColor: showError1 && CorporateTheme?.colors?.danger,
            }}
          />
          {showError1 && (
            <ErrorMessage name={name} render={formErrorMessage} />
          )}
        </div>
      </div>
    </div>
  );
};

export default FormikNumberRangeField;
